// TODO: bundle apollo functions

import { useQuery, useResult } from '@vue/apollo-composable';
import { useRouter } from 'vivat';

import gql from 'graphql-tag';
import {
  reactive, watch, computed, ref, watchEffect,
} from '@vue/composition-api';

const me = reactive({
  id: -1,
  name: '',
  role: '',
  permissions: [],
});

const isAttemptedCheck = ref(false);

export default function useAuth() {
  const { router } = useRouter();

  const {
    result, onResult, onError, refetch,
  } = useQuery(gql`
      query getMyInfo {
        me {
          id
          username
        }
      }
    `, {}, {
    fetchPolicy: 'network-only',
  });

  onError((e: any) => {
    if (String(e).includes('Unauthenticated')) {
      isAttemptedCheck.value = true;
      console.warn('User is not logged in');
      router.push({ name: 'Login' });
      isAttemptedCheck.value = false;
    }
  });

  const myInfo = useResult(result, null, (data: any) => {
    isAttemptedCheck.value = true;
    return data.me;
  });
  watch(myInfo, (newValue) => {
    if (!newValue) return;
    me.id = newValue.id;
    me.name = newValue.username;
    // if (newValue.roles.length > 0) {
    //   me.role = newValue.roles[0].name;
    //   me.permissions = newValue.roles[0].permissions;
    // }
  });

  const isLoggedIn = computed(() => me.id !== -1);

  function hasPermission(permName: string) {
    return computed(() => {
      if (!isAttemptedCheck.value) return true;
      const permArr = me.permissions.map((p: any) => p.name);
      if (permArr.indexOf('*') !== -1) return true;
      if (permArr.indexOf(permName.toLowerCase()) !== -1) return true;
      return false;
    }).value;
  }

  function refresh() {
    refetch();
  }

  // watchEffect(() => {
  //   console.log('isAttemptedCheck: ', isAttemptedCheck.value);
  //   console.log('isLoggedIn: ', isLoggedIn.value);
  //   console.log(JSON.stringify(me));
  // });

  return {
    me,
    refresh,
    isAttemptedCheck,
    isLoggedIn,
    hasPermission,
  };
}
